<script setup lang="ts">
import { SearchX } from "@lucide/vue";
import EmptyState from "@/components/common/EmptyState.vue";
import { Button } from "@/components/ui/button";
import { t } from "@/copy/strings";

definePage({ meta: { title: "Not found" } });
</script>

<template>
  <EmptyState :icon="SearchX" :title="t.errors.pageNotFound" :description="t.errors.pageNotFoundBody" class="mt-8">
    <Button as-child><RouterLink to="/">{{ t.nav.home }}</RouterLink></Button>
    <Button as-child variant="outline"><RouterLink to="/knowledge">{{ t.nav.knowledge }}</RouterLink></Button>
  </EmptyState>
</template>
